import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedAxios } from '../axiosInstance'

const axiosClient = axios.create()

axiosClient.defaults.headers.common = {
	'Content-Type': 'application/json',
	Accept: 'application/json',
	'Access-Control-Allow-Origin': '*',
	'Access-Control-Allow-Credentials': true,
	'Access-Control-Allow-Headers': 'X-Requested-With,content-type'
}

export type NavigatorSummaryInfoResponse = {
	business_desc: string
	company_name: string
	next_earnings_date: string
	herdpulse: string
	logo: string
	herdpower: string
	industry: string
	market_cap: string
	ytd_performance: string
	price: string
	sector: string
	sub_industry: string
	ticker: string
	web_address: string
	safety_margin: 'Low' | 'Medium' | 'High'
	sector_rank: string
	stability_score: '1' | '2' | '3' | '4' | '5'
	price_change: string
	ytd_price_open: string
}

export const fetchNavigatorSummaryInfo = async (
	accessToken: string | undefined,
	ticker?: string
): Promise<NavigatorSummaryInfoResponse> => {
	const response = await axiosClient.get(`${process.env.REACT_APP_API_SERVER}/storage/navigator/summary-info`, {
		headers: {
			Authorization: `Bearer ${accessToken}`
		},
		params: {
			ticker: ticker
		}
	})

	return response.data
}

// New hook that doesn't require passing the access token
export const useNavigatorSummaryInfo = (ticker?: string | null) => {
	const authenticatedAxios = useAuthenticatedAxios()

	return useQuery<NavigatorSummaryInfoResponse>({
		queryKey: ['navigator-summary-info', ticker],
		queryFn: async () => {
			const response = await authenticatedAxios.get(
				`${process.env.REACT_APP_API_SERVER}/storage/navigator/summary-info`,
				{
					params: {
						ticker: ticker
					}
				}
			)
			return response.data
		},
		enabled: !!ticker
	})
}
